import React, { Component } from 'react';
import { connect } from 'react-redux';
import { saveSetup } from './actions';
import ApplicationCard from '../common/ApplicationCard';
import { toggleAppSelection } from './utils';

class App extends Component {
  state = {
    iconPath: '/img/logos/',
  };

  //Θ(1) Stores/Delete the selected app from preferences
  onCheck = () => {
    let setup = this.props.setup;

    const { apps, selectedAppsCount } = toggleAppSelection(
      setup.Apps,
      this.props.app,
      this.props.selectedAppsCount,
    );
    this.props.saveSelectedAppsCount(selectedAppsCount);

    setup.Apps = apps;
    this.props.saveSetup(setup);
  };

  render() {
    const isActive = this.props.setup?.Apps[this.props.app.id] > -1;
    return (
      <React.Fragment>
        <ApplicationCard
          id={this.props.id}
          app={this.props.app}
          data={{ icon: this.state.iconPath + this.props.app.icon }}
          isActive={isActive}
          onClick={this.onCheck}
          showHeart={true}
          showInfo={true}
          showLinks={false}
          hasSchool={true}
          isSetup={this.props.isSetup}
          updateTooltip={this.props.updateTooltip}
          tooltipApp={this.props.tooltipApp}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    setup: state.setupReducer.setup,
  };
};

const mapDispatchToProps = (dispatch) => ({
  saveSetup: (setup) => dispatch(saveSetup(setup)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
